import axios from 'axios'
import React, { useState } from 'react'

const CreateFlightAirline = ({ setUpdateData1 }) => {
    const token = localStorage.getItem('token');
    const [airlineName, setAirlineName] = useState('')
    const [airlineCode, setAirlineCode] = useState('')
    const [image, setImage] = useState(null)
    // airlineCode, airlineName
    const handleAddImage = async () => {
        let message = ''
        try {
            if (airlineName === '' || airlineCode === '' || image === null) {
                if (airlineName === '') message = 'airlineName is required'
                if (airlineCode === '') message = 'airlineCode is required'
                if (image === null) message = 'image is required'
                return alert(message)
            }
            const formData = new FormData()
            formData.append('airlineName', airlineName)
            formData.append('airlineCode', airlineCode)
            formData.append('images', image)
            const response = await axios.post(`https://bharatdarshan.app/api/admin/payment/add-flight-airline-image`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (response?.data?.status===201) {
                setUpdateData1('fTable')
            }
           
        } catch (error) {
            console.log('====================================');
            console.log({ error });
            console.log('====================================');
        }
    }
    return (
        <>
            <div className="row">
                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="text" className="form-control" value={airlineName} onChange={(e) => setAirlineName(e.target.value)} placeholder="Airline Name" />
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="text" className="form-control" value={airlineCode} onChange={(e) => setAirlineCode(e.target.value)} placeholder="Airline Code" />
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <button className='btn btn-info' onClick={() => handleAddImage()}>Add Images</button>
                </div>
            </div>
        </>
    )
}

export default CreateFlightAirline
